// extracted by mini-css-extract-plugin
export var footerColumn = "FooterColumn-module--footerColumn--WRyO1";
export var hiddenUptoDesktopXl = "FooterColumn-module--hiddenUptoDesktopXl--iEYtk";
export var hiddenFromDesktopXl = "FooterColumn-module--hiddenFromDesktopXl--oKvDl";